import { render, staticRenderFns } from "./termsOfService.vue?vue&type=template&id=d63d653e&scoped=true&"
import script from "./termsOfService.vue?vue&type=script&lang=js&"
export * from "./termsOfService.vue?vue&type=script&lang=js&"
import style0 from "./termsOfService.vue?vue&type=style&index=0&id=d63d653e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d63d653e",
  null
  
)

export default component.exports